/**
 * Модуль отзывов: слайдер tiny-slider + «Подробнее» для обрезанного текста.
 */
import 'tiny-slider/dist/tiny-slider.css';
import { tns } from 'tiny-slider/src/tiny-slider';

const REVIEWS_FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

let reviewsSlider = null;

/**
 * tiny-slider ставит aria-hidden на неактивные слайды, но ссылки внутри
 * остаются focusable — убираем их из tab-порядка через inert (+ fallback tabindex).
 */
function syncReviewsHiddenSlideFocus(root) {
    root.querySelectorAll('.reviews__slider .tns-item').forEach((slide) => {
        const isHidden = slide.getAttribute('aria-hidden') === 'true';

        if ('inert' in slide) {
            slide.inert = isHidden;
        }

        slide.querySelectorAll(REVIEWS_FOCUSABLE).forEach((el) => {
            if (isHidden) {
                if (!el.hasAttribute('data-reviews-tabindex')) {
                    el.setAttribute(
                        'data-reviews-tabindex',
                        el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '',
                    );
                }
                el.setAttribute('tabindex', '-1');
            } else if (el.hasAttribute('data-reviews-tabindex')) {
                const prev = el.getAttribute('data-reviews-tabindex');
                el.removeAttribute('data-reviews-tabindex');
                if (prev === '') {
                    el.removeAttribute('tabindex');
                } else {
                    el.setAttribute('tabindex', prev);
                }
            }
        });
    });
}

function initReviewsClumpedText(root) {
    root.querySelectorAll('.reviews__text').forEach((item) => {
        if (item.scrollHeight > item.clientHeight) {
            item.classList.add('clumped');
        }
    });

    root.querySelectorAll('.reviews__more').forEach((item) => {
        item.addEventListener('click', () => {
            root.querySelectorAll('.reviews__text.clumped').forEach((textItem) => {
                textItem.classList.add('expanded');
            });
        });
    });
}

function initReviewsSlider(root) {
    const slider = root.querySelector('.reviews__slider');
    const prevButton = root.querySelector('.reviews__btn--prev');
    const nextButton = root.querySelector('.reviews__btn--next');

    if (reviewsSlider || !slider || !prevButton || !nextButton) {
        return;
    }

    reviewsSlider = tns({
        container: slider,
        items: 1,
        gutter: 8,
        responsive: {
            1200: {
                items: 2,
            },
        },
        controls: true,
        slideBy: 1,
        autoplay: true,
        autoplayButtonOutput: false,
        navPosition: 'bottom',
        arrowKeys: true,
        navAsThumbnails: true,
        prevButton,
        nextButton,
        preventScrollOnTouch: 'force',
    });

    syncReviewsHiddenSlideFocus(root);
    reviewsSlider.events.on('indexChanged', () => syncReviewsHiddenSlideFocus(root));
    reviewsSlider.events.on('transitionEnd', () => syncReviewsHiddenSlideFocus(root));

    requestAnimationFrame(() => initReviewsClumpedText(root));
}

export function initReviews() {
    const root = document.querySelector('.reviews');
    if (!root || root.dataset.reviewsReady === '1') {
        return;
    }
    root.dataset.reviewsReady = '1';

    const slider = root.querySelector('.reviews__slider');
    if (!slider) {
        return;
    }

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, obs) => {
            if (!entries.some((entry) => entry.isIntersecting)) {
                return;
            }

            obs.disconnect();
            requestAnimationFrame(() => initReviewsSlider(root));
        }, {
            rootMargin: '300px 0px',
        });

        observer.observe(slider);
        return;
    }

    requestAnimationFrame(() => initReviewsSlider(root));
}
